import dynamic from 'next/dynamic'

import { IconProps } from '@/components/styleguide/Icon'
import styles from './vehicle-data-spotlight.module.scss'
import { TextSwitchTransition } from '@/lib/animations/TextSwitchTransition'
import { Size } from '@/types/system'

const Icon = dynamic(() => import('@/components/styleguide/Icon'))

export type VehicleDataSpotlightProps = {
  metric: string
  value: string
  label: string
  icon?: IconProps['name']
  includeLabels?: []
  isList?: boolean
}

export const VehicleDataSpotlight = ({ metric, value, label, icon, includeLabels = [], isList = false }: VehicleDataSpotlightProps) => {
  return (
    <div className={styles.spotlight}>
      {icon && (
        <div className={styles.icon}>
          <Icon
            name={icon}
            size={Size.Large}
          />
        </div>
      )}
      <div className={styles.point}>
        {isList ? (
          <div className={styles.value}>{value} {metric} {includeLabels.includes(label) && label.toLowerCase()}</div>
        ) : (
          <>
            <p className={styles.value}>
              <TextSwitchTransition text={value} />
              {` ${metric}`}
            </p>
            <p className={styles.label}>{label}</p>
          </>
        )}
      </div>
    </div>
  )
}
